import { useMotionValueEvent } from "framer-motion"

import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"

import { useSequence } from "./seqcontext"
import { useExp } from "../expcontext"
import { useEffect } from "react"

export default function Sequence({ seqloader, seqloaders }) {
  const console = useConsole()
  const env = useEnv()

  const { frameToDraw, device } = useExp()
  const { curFrameNum } = useSequence()

  useEffect(() => {
    if (seqloaders) {
      Promise.all(
        seqloaders.map(
          sl =>
            new Promise((resolve, reject) => {
              sl.loadFrames(device.get())
                .then(arr => resolve(arr))
                .catch(err => reject(err))
            })
        )
      )
    } else {
      seqloader.loadFrames(device.get())
    }
  }, [seqloader, seqloaders])

  function onFrameNum(f) {
    seqloader[device.get()][f]?.then(im => frameToDraw.set(im))
  }
  useMotionValueEvent(curFrameNum, "change", onFrameNum)

  return null
}
